module.exports = __webpack_public_path__ + "img/mv-tokido.b40f064e.png";